var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDragHorizontallyicon = function SvgDragHorizontallyicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.6 4.8a1.6 1.6 0 1 0 0-3.2 1.6 1.6 0 0 0 0 3.2zM4 8a1.6 1.6 0 1 1 3.2 0A1.6 1.6 0 0 1 4 8zm1.6 3.2a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zm6.4-8a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0zm-1.6 3.2a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zm-1.6 6.4a1.6 1.6 0 1 1 3.2 0 1.6 1.6 0 0 1-3.2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgDragHorizontallyicon;